import React from 'react';
import {Link} from 'react-router-dom';
import {withTranslation} from 'react-i18next';
import _adviserPortalHome from './_adviserPortalHome';


function TotalMembersComponentLeft(props){
    const totalMembersDetails = _adviserPortalHome._totalMembersInDetail(props)
    const {t} = props;
    return(
        <tbody>
                <tr><td><div><Link className="adviserLoginLink link" to="/adv/totalMembers">
                    <div className="adviserDataTotal">{totalMembersDetails.totalMembers}</div>
                    {t('Members:totalMembers')} </Link></div></td></tr>
                {
                    totalMembersDetails.productMembers.map((members, index) => 
                    <tr key={index}><td><div><Link className="adviserLoginDataLink link" to={`/adv/totalMembers/${members.code}`}>
                    <div className="adviserDataSplit">{members.members}</div>
                    {members.name}</Link></div></td></tr>
                    )
                }
                {/* <tr><td><div><Link className="adviserLoginDataLink link" to="/adv/totalMembers/SLKS">
                    <div className="adviserDataSplit">{totalMembersDetails.kiwiSaver}</div>
                    {t('Members:slksMembers')}</Link></div></td></tr>
                <tr><td><div><Link className="adviserLoginDataLink link" to="/adv/totalMembers/SLI">
                    <div className="adviserDataSplit">{totalMembersDetails.invest}</div>
                    {t('Members:sliMembers')}</Link></div></td></tr>
                <tr><td> <div><Link className="adviserLoginDataLink link" to="/adv/totalMembers/SLUK">
                    <div className="adviserDataSplit">{totalMembersDetails.ukPension[0] ? 
                        totalMembersDetails.ukPension[0].length === 0 ? 0 
                        : totalMembersDetails.ukPension : 0}</div>
                    {t('Members:slukMembers')}</Link></div></td></tr> */}
        </tbody>
    )
}

export default withTranslation()(TotalMembersComponentLeft);